<template>
    <el-tooltip
        effect="dark"
        placement="top"
        popper-class="py-1 px-2"
        v-if="message"
    >
        <div slot="content">{{ message }}</div>
        <i class="fa fa-warning text-warning ml-2"/>
    </el-tooltip>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'ValidationTooltip',
    props: {
        field:   { type: String, required: true },
        value:   { required: true }
    },
    computed: {
        ...mapGetters('calculator', ['validateMaxValue']),
        message() {
            return this.validateMaxValue(this.field, this.value);
        }
    }
}
</script>
